import styled from 'styled-components';
import { ContentPage } from '../../../components/ContentPage/ContentPage';
import { Row } from '../../../components/Table/Table';

export const TABLE_HEADER_TASSCARE: Row = {
  email: 'cmp.table.title.email',
  firstName: 'cmp.table.title.firstName',
  lastName: 'cmp.table.title.lastName',
  phone: 'cmp.table.title.phone',
  barcode: 'cmp.table.title.barcode',
  status: 'cmp.table.title.status',
  statusDate: 'cmp.table.title.StatusDate',
  reportReleased: 'cmp.table.title.reportReleased',
};
export const TABLE_HEADER_B2B_REPORTREADY: Row = {
  email: 'cmp.table.title.email',
  firstName: 'cmp.table.title.firstName',
  lastName: 'cmp.table.title.lastName',
  phone: 'cmp.table.title.phone',
  barcode: 'cmp.table.title.barcode',
  status: 'cmp.table.title.status',
  statusDate: 'cmp.table.title.StatusDate',
  reportReleased: 'cmp.table.title.reportReleased',
};
export const TABLE_HEADER_B2B_REPORTREJECTED: Row = {
  email: 'cmp.table.title.email',
  firstName: 'cmp.table.title.firstName',
  lastName: 'cmp.table.title.lastName',
  phone: 'cmp.table.title.phone',
  barcode: 'cmp.table.title.barcode',
  status: 'cmp.table.title.status',
  statusDate: 'cmp.table.title.StatusDate',
  replaced: 'cmp.table.title.replaced',
};

export const RoundBorderContainer = styled.div`
  background: white;
  border-radius: 1em;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0.4rem;
  margin-right: 1.5rem;
  .StatusOverviewDial {
    margin-left: 0.5rem;
  }
`;

export const OverviewStatusLabel = styled.div`
  font-size: 1.5em;
  font-weight: 100;
`;

export const FlexContainer = styled.div`
  display: flex;
  flex-direction:column;
  align-items: center;
  cursor: pointer;
  transition: opacity 0.1s;
  &:hover {
    opacity: 0.8;
  }
`;

export const Quantity = styled.div`
  font-size: 2rem;
  font-weight: bold;
  margin: 0 0.5rem;
  margin-left:1em;
`;

export const Title = styled.div`
  max-width: 9em;
  margin-left:2.2em;
  font-size:1em;
  line-height: 1.2em;
  margin-bottom:0.4em;
`;

export const KitStatusContainer = styled.div`
  display: flex;

  .circle {
    margin-right: 0.75em;
  }
`;

export const ColorIndicator = styled.div`
  border-radius: 100%;
  width: 0.7em;
  height: 0.7em;
  border: 2px solid white;
  flex: 0 0 auto;
  box-shadow: 0 3px 5px;
`;
export const ConfirmationPopUp = styled.div`
  width:40%;
  margin-left:40px;
`;
export const Page = styled(ContentPage)`
  .KitStatusOverview {
    margin-bottom: 1rem !important;
  }
`;